import { Box, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";

import { ICampanhaResumo, ICampanhaRetificacoes } from "../types";
import { RetificacoesTable } from "./Table";

interface IProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  
}

export function Retificacoes({ isOpen, setIsOpen }: IProps) {

  const mockCampanhaRetificacoes: ICampanhaRetificacoes = {
    metrics: [
      { title: 'Totais', value: 10 },
      { title: 'Erros', value: 4 },
      { title: 'Campos vazios', value: 6 },
      { title: 'Dependentes', value: 2 }      
    ],
    result: [
      {
        id: '001',
        nome: 'João Pereira',
        cpf: '123.456.789-00',
        parentesco: 'Titular',
        cargo: '',
        dataNascimento: '1985-04-12',
        sexo: 'M',
        erros: ['CPF inválido', 'Data de nascimento inválida'],
      },
      {
        id: '002',
        nome: 'Maria Oliveira',
        cpf: '234.567.890-11',
        parentesco: 'Dependente',
        cargo: '',
        dataNascimento: '2005-11-30',
        sexo: 'F',
        erros: [],
      },
      {
        id: '003',
        nome: 'Carlos Silva',
        cpf: '345.678.901-22',
        parentesco: 'Titular',
        cargo: 'Auxiliar',
        dataNascimento: '1978-02-03',
        sexo: 'M',
        erros: ['Data de nascimento inválida'],
      },
      {
        id: '004',
        nome: 'Fernanda Lima',
        cpf: '456.789.012-33',
        parentesco: 'Titular',
        cargo: '',
        dataNascimento: '1990-09-25',
        sexo: 'F',
        erros: ['CPF inválido'],
      },
      {
        id: '005',
        nome: 'Pedro Martins',
        cpf: '567.890.123-44',
        parentesco: 'Dependente',
        cargo: '',
        dataNascimento: '2010-06-18',
        sexo: 'M',
        erros: [],
      },
      {
        id: '006',
        nome: 'Luciana Castro',
        cpf: '678.901.234-55',
        parentesco: 'Titular',
        cargo: 'Auxiliar',
        dataNascimento: '1982-01-10',
        sexo: 'F',
        erros: [],
      },
    ],
  };

  return (
    <>
      <div style={{"display":"flex","gap":"1rem"}}>
        {mockCampanhaRetificacoes.metrics.map(({ title, value, count }) => (
          <>              
            <div style={{ width: '100%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '0 16px 16px 16px', display: 'flex', flexDirection: 'column' }}>
              <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>{title}</p>
              <span style={{ fontSize: '20px', lineHeight: '32px', fontWeight: '600', color: '#6F6F78' }}>{value}</span>
            </div>              
          </>
        ))}
      </div>

      <div style={{ marginTop: '24px' }}>
        <RetificacoesTable data={mockCampanhaRetificacoes.result} active={true} />
      </div>
    </>
  );
}
